/**
 * Created by Allan on 2021/04/30.
 * Contact 84880528@qq.com.
 * 全局化过滤器
 * 您还可以在组件定义时的 filters 属性中按需引入
 */
import Vue from 'vue'
import txtDefault from "./txtDefault";  //文字格式化
import txtNumber from "./txtNumber";  //文字格式为数字
import isActive from "./isActive";  //判断当前value是否添加上升或下降样式
import isDwonup from "./isDwonup";
import percentageNum from "./percentageNum";  //取掉value的 %
import moneyFilter from "./moneyFilter";  //金额转换为万元单位


Vue.filter('txtDefault',txtDefault)
Vue.filter('txtNumber',txtNumber)
Vue.filter('isActive',isActive)
Vue.filter('isDwonup',isDwonup)
Vue.filter('percentageNum',percentageNum)
Vue.filter('moneyFilter',moneyFilter)



// WEBPACK FOOTER //
// ./src/filter/index.js